export default {
    invoices() {
        return axios.get("/api/ecommerce/invoices");
    },
    payInvoice(data) {
        return axios.post("/api/ecommerce/invoice/" + data.invoice + "/payment", data);
    },
};
